import type { Api } from '@rialtic/api'
import { computed, useAppConfig, useState } from '#imports'

export const useCurrentUser = () =>
  useState('current-user', (): Api.AuthUserResponse['data'] | null => null)

export const useIsRialticUser = () => {
  return computed(() => {
    const config = useAppConfig()

    if ((config as any).tenant?.hideRialticOnlyViews) {
      return false
    }

    const currentUser = useCurrentUser()

    const email = currentUser.value?.email ?? ''

    return ['@rialtic.io', '@rialtic.email'].some((domain) =>
      email.endsWith(domain),
    )
  })
}
